import React, { memo } from 'react'
import { Path } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase width={size} height={size} viewBox="0 0 24 24" {...otherProps}>
      <Path
        d="M12.3472 1.25153L13.5434 3.90095L16.3381 4.15807C16.6958 4.15807 16.8411 4.6164 16.5505 4.81763L14.5048 6.86338L15.0302 9.5128C15.142 9.84817 14.7507 10.1276 14.4712 9.92643L12.0007 8.64084L9.53015 9.92643C9.2395 10.1388 8.85942 9.85935 8.97121 9.5128L9.49662 6.86338L7.45088 4.81763C7.16023 4.60523 7.31674 4.15807 7.66328 4.15807L10.458 3.90095L11.643 1.25153C11.7548 0.916158 12.2243 0.916158 12.3361 1.25153H12.3472Z"
        fill={color}
      />
      <Path
        d="M4.09655 10.3848L12 13.8167L9.00408 16.8574L1 13.2354L4.09655 10.3848Z"
        stroke={color}
        strokeWidth="1.71"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M4.03125 14.6104V18.5789L12.0018 22.1897"
        stroke={color}
        strokeWidth="1.71"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M19.9035 10.3848L12 13.8167L14.9959 16.8574L23 13.2354L19.9035 10.3848Z"
        stroke={color}
        strokeWidth="1.71"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <Path
        d="M19.9705 14.6104V18.5789L12 22.1897"
        stroke={color}
        strokeWidth="1.71"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <Path
        d="M12 13.8169V22.19"
        stroke={color}
        strokeWidth="1.71"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  )
}

Icon.displayName = 'IconCollectibles'

export const IconCollectibles = memo(themed(Icon))
